import { Link } from "react-router-dom";
import { Bot, MapPin, Scale, ShieldCheck, KeyRound } from "lucide-react";

const T = {
  en: {
    who: "WHO WE ARE", address: "ADDRESS",
    legal: "Legal", privacy: "Privacy Notice", terms: "Terms of Service",
    access: "Access", login: "Log In", register: "Create Account", superadmin: "Super Admin Access",
    rights: "All rights reserved.",
  },
  es: {
    who: "QUIÉNES SOMOS", address: "DOMICILIO",
    legal: "Legal", privacy: "Aviso de Privacidad", terms: "Términos del Servicio",
    access: "Acceso", login: "Entrar", register: "Crear Cuenta", superadmin: "Acceso Super Admin",
    rights: "Todos los derechos reservados.",
  },
};

export const COMPANY = {
  name: "Marketing de Inteligencia Artificial S de RL de CV",
  address: "Av. Américas 1545, Pisos 20, 21 y 22, Colonia Providencia, Guadalajara, Jalisco, México",
  representative: "Ricardo Zermeño Mejía",
};

export const Footer = ({ lang }) => {
  const t = T[lang] || T.en;

  return (
    <footer className="relative border-t border-white/10 bg-[#07070E] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <p className="flex items-center gap-2 font-heading font-black text-sm mb-3">
            <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#B026FF] to-[#00F5FF] flex items-center justify-center"><Bot size={18} /></span>
            AVATAR <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#B026FF] to-[#00F5FF]">4 U</span>
          </p>
        </div>

        <div data-testid="footer-company">
          <h3 className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#00F5FF] mb-3">{t.who}</h3>
          <p className="text-xs text-white/70 font-bold leading-relaxed">{COMPANY.name}</p>
          <h3 className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#00F5FF] mt-5 mb-3">{t.address}</h3>
          <p className="text-xs text-white/50 leading-relaxed flex items-start gap-1.5"><MapPin size={13} className="mt-0.5 shrink-0 text-[#B026FF]" /> {COMPANY.address}</p>
        </div>

        <div>
          <h3 className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#00F5FF] mb-3">{t.legal}</h3>
          <ul className="space-y-2.5">
            <li><Link to="/legal/privacy" data-testid="footer-privacy-link" className="text-xs text-white/60 hover:text-white transition-colors inline-flex items-center gap-1.5"><ShieldCheck size={13} className="text-[#00FFAA]" /> {t.privacy}</Link></li>
            <li><Link to="/legal/terms" data-testid="footer-terms-link" className="text-xs text-white/60 hover:text-white transition-colors inline-flex items-center gap-1.5"><Scale size={13} className="text-[#00FFAA]" /> {t.terms}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#00F5FF] mb-3">{t.access}</h3>
          <ul className="space-y-2.5">
            <li><Link to="/login" data-testid="footer-login-link" className="text-xs text-white/60 hover:text-white transition-colors">{t.login}</Link></li>
            <li><Link to="/register" data-testid="footer-register-link" className="text-xs text-white/60 hover:text-white transition-colors">{t.register}</Link></li>
            <li>
              <Link to="/login" data-testid="footer-superadmin-link"
                className="text-xs font-bold text-[#B026FF] hover:text-[#D080FF] transition-colors inline-flex items-center gap-1.5">
                <KeyRound size={13} /> {t.superadmin}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 py-5 px-6 text-center">
        <p className="text-[10px] text-white/30">© 2026 {COMPANY.name}. {t.rights}</p>
      </div>
    </footer>
  );
};
